import React, { useState } from 'react';
import Intercom from 'react-intercom';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../Contexts/LanguageContext';
import './ChatWithUs.scss';


const ChatWithUs = () => {
  const { getLanguageData } = useLanguage();
  const data = getLanguageData();


  const chatTitle = data.helpSection.heading;
  const emailTitle = data.helpSection.emailHeading;
  const chat = data.helpSection.chat;

  const [isIntercomChatOpen, setIsIntercomChatOpen] = useState(false);
  const openIntercomChat = () => {
    setIsIntercomChatOpen(!isIntercomChatOpen);
  };

  return (
    <>
       <div className="chat-container">
          <h3>{chatTitle}</h3>
          <div className="custom-card social-links">
            <ul>
              {/* <li>
                <Link to="/" onClick={openIntercomChat}>
                  <div className="icon">
                      <img 
                        src='/Assets/images/intercom-icon.svg' 
                        alt={chat.intercom} 
                      />
                  </div>                  
                  <div className="name">{chat.intercom}</div>
                </Link>  
                <Intercom appID="sg9m7arw" />        
              </li> */}
              <li>
              <a href='https://wa.me/+5025703238'>
                  <div className="icon whatsapp">
                      <img 
                        src='/Assets/images/whatsapp-icon.svg' 
                        alt="+502-570-3238" 
                      />
                  </div>
                  <div className="name">+502-570-3238</div>
                </a>                    
              </li>
              {/* <li>
                <Link href='#'>
                <div className="icon">
                      <img 
                        src='/Assets/images/wechat-icon.svg' 
                        alt={chat.weChat} 
                      />
                  </div>
                  <div className="name">{chat.weChat}</div>
                </Link>                    
              </li> */}
            </ul>
            {isIntercomChatOpen && (
              <>
                <div className='message'>
                Click the intercom chat from bottom right to chat with us
                </div>
              </>
            )}
          </div>
          <h3>{emailTitle}</h3>
          <div className="custom-card write-email">
            <ul>
              <li>
              <div className="icon">
                      <img 
                        src='/Assets/images/email-icon.svg'
                        alt={chat.emailAddress} 
                      />
                  </div>
                <div className="name">
                  <Link to="mailto:servicedesk@vascorltd.com">servicedesk@vascorltd.com</Link>
                  {/* <Link to='javascript:void(0)'
                    onClick={() => window.location = 'mailto:contact@focalx.ai'}>
                   {chat.emailAddress}
                </Link> */}
                  </div>
              </li>
            </ul>
          </div>
        </div>        
    </>
  );
};

export default ChatWithUs;
